// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "c2e3144cfdcd9bd8","396": "330f6910fa329844","460": "0ebe00a271783581","498": "3ebf92e83926299d","917": "7ce3439942619506","985": "8d09ea146cf9b948",}[chunkId] + ".chunk.js"
}